import Collapsible from "react-collapsible";
import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material";
import {
  CONDENSED_FONT_LT,
  KahunPrimaryTypography,
} from "fe-web-components/styles/typography";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const expandStyle = {
  position: "relative",
  top: "4px",
  left: "2px",
  fontSize: "large",
} as React.CSSProperties;

const ExpandMore = styled(ExpandMoreIcon)(() => ({ ...expandStyle }));
const ExpandLess = styled(ExpandLessIcon)(() => ({ ...expandStyle }));

const DiseaseSummery = styled(KahunPrimaryTypography)(({ theme }) => ({
  color: KahunColorMap.DefaultLight,
  fontWeight: 400,
}));

const DiseaseSummeryRest = styled(KahunPrimaryTypography)(({ theme }) => ({
  color: KahunColorMap.DefaultLight,
  fontWeight: 400,
}));

const SeeMoreLink = styled(KahunPrimaryTypography)(({ theme }) => ({
  fontFamily: CONDENSED_FONT_LT,
  marginTop: theme.spacing(0),
  fontSize: "14px",
  marginBottom: theme.spacing(3),
  "&:hover": {
    color: KahunColorMap.Default,
  },
  cursor: "pointer",
  color: KahunColorMap.Default,
}));

const SUMMERY_CHARS_LIMIT = 150;

const splitDescription = (description: string): [string, string | null] => {
  const spaceAfterLimit = description.indexOf(" ", SUMMERY_CHARS_LIMIT);
  if (spaceAfterLimit < 0) return [description, null];

  const summery = description.substring(0, spaceAfterLimit);
  const rest = description.substring(spaceAfterLimit + 1);
  return [summery, rest];
};

export const DescriptionAccordion = ({
  description,
  onShowMore,
}: {
  description: string;
  onShowMore?: (boolean) => void;
}) => {
  const [descriptionOpened, setDescriptionOpen] = useState<boolean>(false);
  if (!description) return null;
  const [summery, rest] = splitDescription(description);

  return (
    <>
      <Collapsible
        triggerDisabled={true}
        open={descriptionOpened}
        trigger={<DiseaseSummery>{summery}</DiseaseSummery>}
      >
        <DiseaseSummeryRest>{rest}</DiseaseSummeryRest>
      </Collapsible>

      {rest && (
        <SeeMoreLink
          onClick={() => {
            onShowMore && onShowMore(!descriptionOpened);
            setDescriptionOpen((prevState) => !prevState);
          }}
        >
          {`Show ${descriptionOpened ? "Less" : "More"}`}

          {descriptionOpened ? <ExpandLess /> : <ExpandMore />}
        </SeeMoreLink>
      )}
    </>
  );
};
